import { create } from 'zustand';

/**
 * How payment rows are grouped in the list view.
 * - `'none'` — flat list, workers aggregated across pots
 * - `'pot'` — grouped by pot reference
 * - `'gang'` — grouped by gang/solo classification
 */
export type PaymentGroupingMode = 'none' | 'pot' | 'gang';

interface PaymentsUIState {
  collapsedGroups: Set<string>;
  groupingMode: PaymentGroupingMode;
}

interface PaymentsUIActions {
  toggleGroup: (name: string) => void;
  setGroupingMode: (mode: PaymentGroupingMode) => void;
  reset: () => void;
}

export const usePaymentsUIStore = create<PaymentsUIState & PaymentsUIActions>(
  set => ({
    collapsedGroups: new Set(),
    groupingMode: 'none',
    toggleGroup: (name: string) =>
      set(state => {
        const next = new Set(state.collapsedGroups);
        if (next.has(name)) {
          next.delete(name);
        } else {
          next.add(name);
        }
        return { collapsedGroups: next };
      }),
    setGroupingMode: (mode: PaymentGroupingMode) =>
      set({ groupingMode: mode, collapsedGroups: new Set() }),
    reset: () => set({ collapsedGroups: new Set(), groupingMode: 'none' }),
  })
);
